import React, { useState } from 'react';
import { Popover, Stack, Typography, Tooltip, Chip } from '@mui/material';
import { IJob } from '../../types';

const MAX_VISIBLE_CHIPS = 1;
const MAX_CHIP_WIDTH = 160;

type ChipProps = Pick<IJob, 'id' | 'title'>;

const renderChip = (job: { id: number; title: string }, index: number) => {
  return (
    <Tooltip key={job.id} title={job.title} placement="top" arrow>
      <Chip
        label={job.title}
        sx={{
          height: '32px',
          backgroundColor: '#EDF2F5',
          color: '#084D6D',
          fontWeight: 'bold',
          border: '2px solid white',
          marginLeft: index === 0 ? 0 : '-8px',
          zIndex: MAX_VISIBLE_CHIPS - index,
          maxWidth: MAX_CHIP_WIDTH,
          '& .MuiChip-label': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        }}
      />
    </Tooltip>
  );
};

export default function GroupedChips({ jobs }: { jobs: ChipProps[] }) {
  const [chipAnchorEl, setChipAnchorEl] = useState<HTMLDivElement | null>(null);

  return (
    <>
      <Stack direction="row">
        {jobs.length <= MAX_VISIBLE_CHIPS ? (
          jobs
            .slice(0, MAX_VISIBLE_CHIPS)
            .map((job, index) => (
              <React.Fragment key={job.id}>{renderChip(job, index)}</React.Fragment>
            ))
        ) : (
          <Stack direction="row">
            {jobs.slice(0, 1).map((job, index) => (
              <React.Fragment key={job.id}>{renderChip(job, index)}</React.Fragment>
            ))}
            <Chip
              label={`+ ${jobs.length - 1}`}
              onClick={(e) => setChipAnchorEl(e.currentTarget)}
              sx={{
                height: '32px',
                backgroundColor: '#EDF2F5',
                color: '#084D6D',
                fontWeight: 'bold',
                marginLeft: '-10px',
                zIndex: 0,
                border: '2px solid white',
                '& .MuiChip-label': {
                  fontSize: '12px',
                  padding: '0px 6px 0px 12px'
                }
              }}
            />
          </Stack>
        )}
      </Stack>
      <Popover
        open={Boolean(chipAnchorEl)}
        anchorEl={chipAnchorEl}
        onClose={() => setChipAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        sx={{ '& .MuiPaper-root': { marginTop: 1 } }}
      >
        <Stack sx={{ padding: '8px 16px', rowGap: '4px' }}>
          {jobs.slice(1).map((job) => (
            <Typography key={job.id}>{job.title}</Typography>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
